import { useIntl } from 'react-intl';
import { Typography } from '@bolteu/clay-react';

import { PerformanceTier } from '@provider-portal/common/api/openapi_gen/deliveryProviderPortal/deliveryProviderPortal/models';

import { TIER_BENEFITS, TierBenefit, TierBenefitId } from '../tierBenefits';

export interface BenefitsProgressProps {
  tier: PerformanceTier;
  benefitLabelKeys: Record<TierBenefitId, string>;
}

function BenefitIcon({ icon: Icon }: Pick<TierBenefit, 'icon'>) {
  if (typeof Icon === 'string') {
    return <img src={Icon} alt="" className="size-5 shrink-0" />;
  }
  return <Icon className="text-tertiary shrink-0" size="sm" />;
}

export function BenefitsProgress({ tier, benefitLabelKeys }: BenefitsProgressProps) {
  const intl = useIntl();
  const benefits: TierBenefit[] | undefined = TIER_BENEFITS[tier];

  if (!benefits) {
    return null;
  }

  return (
    <div className="flex flex-row flex-wrap gap-x-3 gap-y-2 justify-center w-full md:max-w-110 md:gap-x-2">
      {benefits.map(({ id, icon }) => (
        <div key={id} className="flex flex-row gap-2 items-center min-w-0 max-w-full">
          <BenefitIcon icon={icon} />

          <Typography className="bolt-font-body-s-regular md:bolt-font-body-m-regular text-left min-w-0">
            {intl.formatMessage({ id: benefitLabelKeys[id] })}
          </Typography>
        </div>
      ))}
    </div>
  );
}
